import { render, staticRenderFns } from "./ABigScreemCenter.vue?vue&type=template&id=4a5ab741&scoped=true&"
import script from "./ABigScreemCenter.vue?vue&type=script&lang=js&"
export * from "./ABigScreemCenter.vue?vue&type=script&lang=js&"
import style0 from "./ABigScreemCenter.vue?vue&type=style&index=0&id=4a5ab741&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5ab741",
  null
  
)

export default component.exports